<script lang="ts">
import { defineComponent } from 'vue'
export default defineComponent({
  name: 'TlbsInput',
  
})
</script>
<template>
  <t-input v-bind="$attrs">
    <template
      v-if="props.prefixIcon"
      #prefixIcon
    >
      <t-icon :name="props.prefixIcon" />
    </template>
    <template
      v-if="props.suffixIcon"
      #suffixIcon
    >
      <t-icon :name="props.suffixIcon" />
    </template>
  </t-input>
</template>
<script lang="ts" setup  name="TlbsInput">
interface Prop {
  prefixIcon?: string;
  suffixIcon?: string;
}

const props = withDefaults(defineProps<Prop>(), {
  prefixIcon: '',
  suffixIcon: '',
});
</script>
